import { initContract } from '@ts-rest/core'
import {
    AdminReportAuditEventRequestSchema,
    AdminReportAuditEventResponseSchema,
} from '../schemas/admin-report-audit'
import { defaultErrorResponses } from './errors'

const c = initContract()

/**
 * Admin Report Audit Contract - issue #354 (epic #306, wave 1, slice #3).
 *
 * Single endpoint that the Evidence.dev reverse proxy (slice #355) and the
 * admin CLI use to record every admin-report interaction. Writes go to a
 * dedicated `admin_report_audit_events` table, NOT user-facing
 * `activity_logs`.
 *
 * Auth posture:
 *   - Bearer token must be a valid Supabase session.
 *   - The session user must be an admin (gated server-side).
 *   - Non-admin authenticated users receive 403.
 *
 * Privacy contract:
 *   - `params_json` may only contain ids, slugs, and filter params.
 *   - Any payload containing email content keys (subject/snippet/body/…)
 *     is rejected at the writer level with VALIDATION_ERROR.
 */
export const adminReportAuditContract = c.router({
  recordEvent: {
    method: 'POST',
    path: '/v1/admin/report-audit',
    body: AdminReportAuditEventRequestSchema,
    responses: {
      201: AdminReportAuditEventResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      adminOnly: true,
      summary: 'Record an admin report audit event',
      description:
        'Persists one row in admin_report_audit_events for a view/generate/export/denied action. Used by the Evidence.dev reverse proxy and admin CLI; not for end users.',
    },
  },
})
